import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { log } from '../utils/console-logger';

@Injectable()
export class AppCookieService {

  // if U want log raw data save into cookies, set enableCoding to false and enableConsoleLogs to true
  readonly enableConsoleLogs = false;

  readonly PATH = '/';
  readonly DOMAIN = null;

  constructor(private cookieService: CookieService) {
  }

  set(name: string, value: any, expires?: number | Date, enableCoding = true): void {
    const cookieName = enableCoding ? btoa(name) : name;
    const stringifyValue = JSON.stringify(value);
    const cookieValue = enableCoding ? btoa(stringifyValue) : stringifyValue;

    log({service: 'AppCookieService', method: 'set: ', value: {'cookieName': cookieName, 'cookieValue': cookieValue}}, this.enableConsoleLogs);

    this.cookieService.set(cookieName, cookieValue, expires, this.PATH, this.DOMAIN, false, 'Lax');
  }

  get(name: string, enableCoding = true): any {
    const cookieName = enableCoding ? btoa(name) : name;
    const cookieValue = this.cookieService.get(cookieName);
    let resultValue = null;

    if (cookieValue) {
      const decodedValue = enableCoding ? atob(cookieValue) : cookieValue;
      try {
        resultValue = JSON.parse(decodedValue);
      } catch (err) {
        resultValue = decodedValue;
      }
    }

    log({service: 'AppCookieService', method: 'get', value: resultValue}, this.enableConsoleLogs);

    return resultValue;
  }

  clear(name: string, enableCoding = true): void {
    const cookieName = enableCoding ? btoa(name) : name;
    this.cookieService.delete(cookieName, this.PATH, this.DOMAIN);

    log({service: 'AppCookieService', method: 'delete: ', value: {'cookieName': cookieName}}, this.enableConsoleLogs);
  }

}
